<!--  -->
<template>
  <div class="">
    <WrapCard title="计费模板">
      <!-- 查询 -->
      <JiuyuSearchForm :requestParams="requestParams" :searchFromParams="searchFromParams">
        <template v-slot:btnLeft>
          <el-button style="margin-right: 30px" type="primary" @click="getList(1)" size="mini">查询</el-button>
        </template>
        <template v-slot:btn>
          <el-button style="margin-right: 30px" type="primary" size="mini" @click="openAddDialog()">新增</el-button>
        </template>
      </JiuyuSearchForm>

      <!-- 表格 -->
      <JiuyuTable :tabelParams="tabelParams" :requestParams="requestParams">
        <!-- 状态 -->
        <template v-slot="row">
          <el-button size="mini" type="primary" @click="detail(row)">查看</el-button>
          <el-button size="mini" type="warning" @click="edit(row)">修改</el-button>
          <el-button size="mini" type="danger" @click="deleteItem(row.row.id)">删除</el-button>
        </template>
      </JiuyuTable>
    </WrapCard>

    <!-- 弹窗 -->

    <el-dialog :title="showName" :visible.sync="AddDialogVisible" width="50%" center :show-close="false">
      <div>
        <el-form :model="addObject" :rules="rules" ref="addObject" label-width="100px" class="demo-ruleForm">
          <div>
            <el-form-item style="display: inline-block" label-width="80px" label="计费方式" prop="chargeType">
              <el-select size="mini" style="width: 140px" :disabled="showDetail" v-model="addObject.chargeType" placeholder="请选择计费方式">
                <el-option v-for="(item, index) in calculateTypeList" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label-width="80px" label="进位方式" prop="scale" style="display: inline-block">
              <el-select size="mini" style="width: 140px" :disabled="showDetail" v-model="addObject.scale" placeholder="请选择进位方式">
                <el-option v-for="(item, index) in scaleList" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="模板名称" label-width="80px" style="display: inline-block" prop="sectionName">
              <el-input size="mini" :disabled="showDetail" placeholder="请输入模板名称" v-model="addObject.sectionName"></el-input>
            </el-form-item>
            <el-form-item label="备注" label-width="80px" prop="remark">
              <el-input style="width: 90%" :disabled="showDetail" type="textarea" placeholder="请输入备注" v-model="addObject.remark"></el-input>
            </el-form-item>
          </div>

          <div class="dynamicInputSection" v-for="(item, index) in addObject.detailList" :key="index">
            <el-form-item style="display: inline-block" :rules="[{ validator: validatePass, trigger: 'blur' }]" :label="`区间${index + 1}`" inline-message :prop="'detailList.' + index + '.sectionStartNum'">
              <el-input size="mini" placeholder="大于" style="width: 150px" :disabled="showDetail" v-model="addObject.detailList[index].sectionStartNum"></el-input>
            </el-form-item>
            <span>至</span>
            <el-form-item style="display: inline-block" :rules="[{ validator: validatePass, trigger: 'blur' }]" label-width="0" inline-message :prop="'detailList.' + index + '.sectionEndNum'">
              <el-input size="mini" :disabled="showDetail" placeholder=" 小于等于" style="width: 150px" v-model="addObject.detailList[index].sectionEndNum"></el-input>
            </el-form-item>
            <span v-if="index == 0 && !showDetail" style="color: #5f4aff; cursor: pointer" @click="addListItem(addObject.detailList)">
              新增区间段
            </span>
            <span v-if="!showDetail && !(index == 0)" @click="deleteListItem(index, addObject.detailList)" style="color: #ff3333; cursor: pointer">
              删除
            </span>
            <!-- <el-button
              :disabled="showDetail"
              size="mini"
              type="danger"
              style="float: right; margin: 7px"
              @click="deleteListItem(index, addObject.detailList)"
              >删除</el-button
            > -->
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancel()">取 消</el-button>
        <el-button size="mini" v-if="!showDetail" type="primary" @click="submitForm('addObject')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-if="showObject" title="查看计费模板" :visible.sync="showDetail" width="45%" center>
      <div style="display: flex; flex-wrap: wrap">
        <div v-for="(item, index) in showObjectDetail" :key="index" style="width: 220px; margin: 10px 0" :style="{ width: item.prop == 'remark' ? '100%' : '220px' }">
          <div style="display: inline-block; color: #999999; width: 80px">
            <div>{{ item.name }}</div>
          </div>
          <span>{{ showObject[item.prop] }}</span>
        </div>
      </div>
      <!-- 备注 -->
      <div style="margin: 10px 0; width: 100%; ">
        <div style="display: inline-block; color: #999999; width: 80px">
          <div>备注</div>
        </div>
        <span>{{ showObject["remark"] }}</span>
      </div>
      <!-- 区间 -->
      <div v-for="(item,index) in showObject.detailList" :key="index" style="margin:8px 0;">
        <div style="display: inline-block; color: #999999; width: 80px">
          <div>区间{{index +1}}</div>
        </div>
        <div class="inputStyle">
          <span style="margin: 0 10px ;color: #999999;">大于</span>
          <span>{{item.sectionStartNum}}</span>
          <div style="float:right;margin-right:50px;">
            <span style="margin-right: 10px">至</span>
            <span style="margin-right: 10px;color: #999999;">小于等于</span>
            <span>{{item.sectionEndNum}}</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="showDetail = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import myUtils from "./../../../common/jackUtils";
import WrapCard from "./jack-components/wrap-card";
import JiuyuSearchForm from "./jack-components/jiuyu-search-form";
import JiuyuTable from "./jack-components/jiuyu-table";

export default {
  components: { WrapCard, JiuyuSearchForm, JiuyuTable },
  data () {
    return {
      showObjectDetail: [
        { name: "计费方式", prop: "chargeType" },
        { name: "模板名称", prop: "sectionName" },
        { name: "进位方式", prop: "scaleMsg" },
      ],
      showObject: {
        chargeType: "",
        detailList: [
          {
            chargeSectionHeaderId: 0,
            id: 0,
            sectionEndNum: "",
            sectionStartNum: "",
          },
        ],
        id: 0,
        remark: "",
        scale: "",
        sectionName: "",
      },
      validatePass: (rule, value, callback) => {
        // console.log(rule);
        // console.log(value);
        // "detailList.0.sectionStartNum"
        let tempList = rule.field.split(".");
        if (tempList[2] == "sectionEndNum") {
          // 这里有坑 必须parseFloat一下，不然  111>33 即使是true 也会执行 Error
          parseFloat(
            this.addObject[`${tempList[0]}`][tempList[1]].sectionEndNum
          ) >
            parseFloat(
              this.addObject[`${tempList[0]}`][tempList[1]].sectionStartNum
            )
            ? callback()
            : callback(new Error(`必须大于前一项`));
        } else {
          if (value === "") {
            callback(new Error(`请输入区间`));
          } else {
            // if (this.ruleForm.sectionStartNum !== "") {
            // this.$refs.ruleForm.validateField("sectionStartNum");
            // }
            callback();
          }
        }
      },

      AddDialogVisible: false,
      calculateTypeList: ["KG", "CBM"],
      // -1:不进位 0：以1进位 1:以0.1进位
      scaleList: [
        { label: "不进位", value: -1 },
        { label: "以1进位", value: 0 },
        { label: "以0.1进位", value: 0.1 },
      ],
      addObject: {
        chargeType: "",

        detailList: [
          {
            chargeSectionHeaderId: 0,
            id: 0,
            sectionEndNum: "",
            sectionStartNum: "",
          },
        ],
        id: 0,
        remark: "",
        scale: "",
        sectionName: "",
      },
      list: [],
      // 组件数据
      requestParams: {
        chargeType: "",
        sectionName: "",
        state: null, //状态，1：草稿，2：发布，3：作废
        // base

        curPage: 1,
        pageSize: 10,
        total: 0,
      },

      searchFromParams: {
        call: (param) => {
          return Object.prototype.toString.call(param) === "[object Function]";
        },
        outSideStyle: {
          // 整个查询整体宽度
          width: "60%",
          display: "flex",
          // 是否换行
          "flex-wrap": "wrap",
          "align-items": "center",
          "pdding-bottom": "20px",
        },
        mainSearchList: [
          {
            type: "select",
            divWidth: "",
            needAutoQuery: false,
            selectLabel: "label",
            selectValue: "value",
            spanName: "计费方式",
            spanWidth: "80px",
            modelObj: {
              objName: "requestParams",
              value: "chargeType",
            },
            list: () => {
              return this.calculateTypeList.slice(0).map((item) => {
                return { label: item, value: item };
              });
            },
            event: {
              focus: (val) => { },
              changeProduct: (i, autoQuery) => { },
              clear: (i) => {
                this.getList(1);
              },
            },
            margin: "10px 10px",
          },
          {
            type: "input",
            size: "mini",
            inputWidth: "250px",
            needAutoQuery: false,
            Name: "模板名称",
            placeholder: "",
            modelObj: {
              objName: "requestParams",
              value: "sectionName",
            },
            event: {
              clear: (i) => {
                this.getList(1);
              },
            },
            margin: "0 10px 0 0",
          },
        ],
      },
      // 表格
      tabelParams: {
        tabelStyle: {
          margin: "10px 0",
          minWidth: "980px",
        },
        hideOperate: false,
        operateWidth: "220px",
        size: "mini",
        datas: {
          tableData: () => {
            return this.list;
          },
          // 表头数据
          innerData: () => {
            return [
              // 需要序号就添加 type
              { name: "序号", value: "", type: "index", width: "60" },
              { name: "计费方式", value: "chargeType" },
              { name: "模板名称", value: "sectionName" },
              { name: "进位方式", value: "scaleMsg" },
              { name: "备注", value: "remark" },
              { name: "录入人", value: "inputer" },
              { name: "录入时间", value: "inputtime" },
              //  <template slot-scope="scope">
              //     <span v-if="scope.row.state == 1">草稿</span>
              //     <span v-if="scope.row.state == 2">发布</span>
              //     <span v-if="scope.row.state == 3">作废</span>
              //   </template>
            ];
          },
        },
        event: {
          sizeChange: (val) => {
            // console.log(this);
            this.requestParams.pageSize = val;
            this.getList();
          },
          currentChange: (val) => {
            this.requestParams.curPage = val;
            this.getList();
          },
        },
        tableEvent: {
          needCopy: true,
          getListById: (id, val) => {
            // console.log(id);
            return this.getListById(id);
          },
          updatestate: (id, val) => {
            // console.log(id,val);
            return this.updatestate(id, val);
          },
          copy: (id) => {
            // console.log(id,val);
            return this.copy(id);
          },
        },
      },
      myForm: {
        ruleForm: {
          name: "",
          region: "",
          date1: "",
          date2: "",
          delivery: false,
          type: [],
          resource: "",
          desc: "",
        },
        fromArray: [{}],
      },

      rules: {
        sectionName: [
          { required: true, message: "请输入模板名称", trigger: "blur" },
        ],
        scale: [
          { required: true, message: "请选择进位方式", trigger: "change" },
        ],
        chargeType: [
          { required: true, message: "请选择计费方式", trigger: "change" },
        ],

        date2: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        type: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change",
          },
        ],
        resource: [
          { required: true, message: "请选择活动资源", trigger: "change" },
        ],
        desc: [{ required: true, message: "请填写活动形式", trigger: "blur" }],
      },
      clearAll: () => { },
      showDetail: false,
    };
  },
  mounted () {
    myUtils.clearAddObject(this, "addObject");
    this.getList();
    // this.getCalculateTypeList();
  },
  computed: {
    showName () {
      let name = !this.addObject.id ? "添加计费模板" : "修改计费模板";
      return name;
    },
  },

  methods: {
    deleteListItem (index, list) {
      if (list.length == 1) {
        return this.$message.info("最少保留一个");
      }

      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          list.splice(index, 1);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    addListItem (list) {
      list.push({
        chargeSectionHeaderId: 0,
        id: 0,
        sectionEndNum: "",
        sectionStartNum: "",
      });
    },
    detail (row) {
      this.showObject = row.row;
      // this.AddDialogVisible = true;
      this.showDetail = true;
    },
    deleteItem (id) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .get(`/carrier/chargeSection/deleteChargeSection/${id}`)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message.success("删除成功");
                this.getList(1);
              } else {
                this.$message.info(res.data.message);
              }
            })
            .catch((res) => {
              console.log(res);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    edit (row) {
      console.log(row);
      this.axios.get(`/carrier/chargeSection/getChargeSectionInfo/${row.row.id}`)
        .then((res) => {
          if (res.data.code == 200) {
            this.addObject = res.data.data;
            this.AddDialogVisible = true;
          } else {
            this.$message.info(res.data.message);
          }
        }).catch((res) => {
          console.log(res);
        });


    },
    add (id) {
      // row.row.id
      id ? (this.addObject.id = id) : "";
      this.axios
        .post(
          `/carrier/chargeSection/createOrUpdateChargeSection`,
          this.addObject
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success("添加成功");
            this.getList();
            this.cancel();
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    cancel () {
      this.AddDialogVisible = false;
      setTimeout(() => {
        this.showDetail = false;
      }, 300);
      this.clearAll();
    },
    openAddDialog () {
      this.AddDialogVisible = true;
    },

    getCalculateTypeList () {
      this.getBaseList(
        {
          methods: "post",
          params: {},
        },
        "/filedata/findFbaChargeTypeAll",
        "获取FBA计费方式列表",
        "calculateTypeList"
      );
    },
    getList (isQuery) {
      if (isQuery) {
        this.requestParams.curPage = 1;
      }
      this.getBaseList(
        {
          methods: "post",
          params: {
            chargeType: this.requestParams.chargeType,
            pageNum: this.requestParams.curPage,
            pageSize: this.requestParams.pageSize,
            sectionName: this.requestParams.sectionName,
          },
        },
        "/carrier/chargeSection/getCarrierChargeSectionList",
        "获取线路商计费模板列表",
        "list"
      );
    },
    getBaseList (methods, url, name, listName) {
      this.axios[methods.methods](
        `${url}`,
        methods.params ? methods.params : ""
      )
        .then((res) => {
          console.log(`------------获取 ${name}-------------`);
          console.log(res.data.data);
          if (res.data.code == 200) {
            this[listName] =
              (res.data.data &&
                res.data.data.list.length &&
                res.data.data.list) ||
              this.$message.info(`${name} 没有相关数据`);
            this.requestParams.total = res.data.data.total;
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert("submit!");
          this.add();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style  scoped>
.el-form-item {
  margin: 10px 0;
}
.dynamicInputSection {
}
.inputStyle {
  display: inline-block;
  width: 300px;
  border: 1px solid #dcdcdc;
  border-radius: 5px;
  padding: 6px;
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/components/QuotationManagement/ChargingTemplate.vue